

import React from 'react';
import {useTranslation} from "react-i18next";
import BASIC_INFORMATION from "../../data/basic_data";
import * as FaIcons from "react-icons/fa";
import {MotionAnimate} from "react-motion-animate";

function WelcomeSection(props) {

    const { t, i18n } = useTranslation()

    return (<section id={'welcome-section'} className={'bg-image-1 container vh-100 d-flex flex-column justify-content-around p-md-0 p-5'}>
        <div className={'bg-imag- text-start'}>
            {/*<img*/}
            {/*     src={'/assets/img/git.gif'}*/}
            {/*     // src={'https://camo.githubusercontent.com/4d9f5ecceb711eec6e2018f38a5677dc657c9738d4a65ba3b928c41c0a45b439/68747470733a2f2f6d69726f2e6d656469756d2e636f6d2f6d61782f313336302f302a37513379765349765f7430696f4a2d5a2e676966'}*/}
            {/*     // src={'https://www.techspot.com/images2/news/bigimage/2025/06/2025-06-09-image-33.jpg'}*/}
            {/*     // src={'https://cdn.dribbble.com/userupload/19811246/file/original-4286c97f5118f099deaafce6ca7ebee6.gif'}*/}
            {/*     // src="https://cdn.dribbble.com/userupload/22660740/file/original-8c1f9ac2f5421a6b143cba0599d91227.gif"*/}
            {/*     alt="image gif"*/}
            {/*     className={'img-fluid'}*/}
            {/*/>*/}
            {/*<img src="/assets/img/iphone.jpg" alt="iphone.jpg" className={'img-fluid vh-100'}/>*/}

            <h1 className={'display-1 fw-bold'}>
                Software Development <br/> and Innovations Partner
            </h1>
            <p className={'text-secondary fs-4'}>
                We build, grow and support high-grade solutions for businesses across the globe, <br/> backed by a proven track record of success.
            </p>

            {/*<p className={'display-1 col-md-12 col-12'}>*/}
            {/*    We craft beautiful develop  experiences*/}
            {/*</p>*/}
            {/*<p className={'lead pt-2'} style={{paddingRight: '20px'}}>*/}
            {/*    Powering Innovative Mobile and Web Apps with ❤️*/}
            {/*</p>*/}
        </div>
    </section>);
}

export default WelcomeSection;
